// extracted by mini-css-extract-plugin
module.exports = {"layout":"_93444fe79c--layout--YJ5m5"};